import {
  TrendingUp,
  TrendingDown,
} from "lucide-react";

const EmissionCard = ({ type, data, emissionTypes }) => {

const baseEmissionData = data?.[type] || {};
const useSummaryTypes = ["sox", "nox"];

const computedCurrent = useSummaryTypes.includes(type)
  ? data?.summary?.totalEmissions?.[type] ?? 0
  : baseEmissionData?.current ?? 0;

  const emissionData = {
    current: Number(computedCurrent),
    target: Number(baseEmissionData?.target ?? 0),
    change: Number(baseEmissionData?.change ?? 0),
    unit: baseEmissionData?.unit ?? "g/kWh",
  };

  // console.log("data12", data);
  // console.log("emissionData:", emissionData);

  const IconComponent = emissionTypes[type].icon;
  const isCompliant = emissionData.current <= emissionData.target;
  const change = emissionData.change || 0;
  const current = emissionData.current || 0;
  const target = emissionData.target || 0;
  const unit = emissionData.unit || "g/kWh";
  const percent = target > 0 ? Math.min((current / target) * 100, 100) : 0;

  const formatChange = (value) => {
    if (isNaN(value)) return "0.00";
    const str = value.toString();
    if (!str.includes(".")) return str + ".00";

    const [intPart, decPart] = str.split(".");
    return intPart + "." + decPart.padEnd(2, "0").slice(0, 3);
  };

  return (
    <div
      className={`
        group rounded-2xl border bg-white p-5 shadow-sm transition-all duration-300
        hover:shadow-[0_8px_30px_rgba(0,0,0,0.08)]
        hover:scale-[1.015] hover:border-transparent
        min-h-[260px] flex flex-col justify-between relative overflow-hidden
      `}
    >
      {/* Hover Shine Effect */}
      <div className="absolute inset-0 pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-500">
        <div className="absolute -top-1/4 -left-1/4 w-[150%] h-[150%] bg-gradient-to-tr from-[#e0f7ff] to-transparent rotate-12 blur-xl opacity-40 animate-pulse"></div>
      </div>

      {/* Header */}
      <div className="flex items-start gap-3 relative z-10">
        <div
          className={`
            p-2 rounded-md transition-colors
            ${isCompliant ? 'bg-emerald-100 text-emerald-600' : 'bg-rose-100 text-rose-600'}
          `}
        >
          <IconComponent className="w-5 h-5" />
        </div>
        <div>
          <h3 className="text-sm font-semibold text-slate-700">
            {emissionTypes[type].symbol}
          </h3>
          <p className="text-xs text-slate-500">{emissionTypes[type].label}</p>
        </div>
      </div>

      {/* Metrics */}
      <div className="text-sm text-slate-700 mt-4 space-y-2 relative z-10">
        <div className="flex justify-between">
          <span className="text-slate-500">Current</span>
          <span className="text-base font-semibold">
            {current}{" "}
            <span className="text-xs text-slate-500">{unit}</span>
          </span>
        </div>
        <div className="flex justify-between">
          <span className="text-slate-500">Target</span>
          <span>{formatChange(target)} {unit}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-slate-500">Deviation</span>
          {/* <span
            className={`flex items-center gap-1 font-semibold ${
              change >= 0 ? "text-rose-600" : "text-emerald-600"
            }`}
          > */}
          {/* {change >= 0 ? (
              <TrendingUp className="w-4 h-4" />
            ) : (
              <TrendingDown className="w-4 h-4" />
            )} */}
          {/* {Math.abs(change).toFixed(1)}% */}
          {/* {formatChange(change)}%
          </span> */}
          <span
            className={`flex items-center gap-1 font-semibold ${change > 0
                ? "text-rose-600"
                : change < 0
                  ? "text-emerald-600"
                  : "text-gray-600"
              }`}
          >
            {change > 0 ? (
              <TrendingUp className="w-4 h-4" />
            ) : change < 0 ? (
              <TrendingDown className="w-4 h-4" />
            ) : null}

            {formatChange(change)}%
          </span>

        </div>
      </div>

      {/* Progress Bar */}
      <div className="mt-5 relative z-10">
        <div className="flex justify-between text-xs text-slate-500 mb-1">
          <span>vs Target</span>
          <span className="font-semibold">{formatChange(percent)}%</span>
        </div>
        <div className="w-full h-2 rounded-full bg-slate-200 overflow-hidden">
          <div
            className={`
              h-full rounded-full transition-all duration-500
              ${isCompliant ? "bg-emerald-500" : "bg-rose-500"}
            `}
            style={{ width: `${percent}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default EmissionCard;
